<template>
  <b-modal
    ref="confirmWebhookDisable"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable>

    <b-alert
      variant="light-danger"
      show
      class="mb-0">
      <p class="font-size-lg mb-0">
        When disabling webhooks in the project, be aware that it may result in the cancellation of all current and future events affecting your application's functionality. This could lead to process interruptions and data loss. It is advisable to carefully consider this decision and consult with your development team.
      </p>
    </b-alert>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('confirmWebhookDisable')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="webhookResponses('disableWebhook')"
          @click="disableWebhook(), hideModal('confirmWebhookDisable')">
          Yes, turn it off
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  DISABLE_WEBHOOK,
  GET_WEBHOOK_DATA
} from '@/core/services/store/reseller_webhook.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalDisableWebhook',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'integrationsList',
      'failedGetResellerStatus',
      'failedIntegrationGetStatus',
      'webhookApiKey',
      'webhookApiKeyExist',
      'webhookIpLimitsLength',
      'webhookIpLimitsEmpty',
      'webhookIpLimitsChanged',
      'webhookIpLimitsSnapshot',
      'webhookResponses'
    ]),

    routeId() {
      return this.$route.params.id
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    disableWebhook() {
      this.$store
        .dispatch(DISABLE_WEBHOOK, { id: this.routeId })
        .then(() => {
          this.$store.dispatch(GET_WEBHOOK_DATA, { id: this.routeId })
        })
    }
  }
}
</script>
